import React from 'react';
import { Box, Stack, Tooltip, Typography } from '@mui/material';

import NivelChip from './NivelChip';
import ValorQueChega from './ValorQueChega';

/**
 * O número que dá o veredito do bloco: valor grande, faixa ao lado, frase
 * abaixo — nesta ordem, que é a de um relatório de agência de rating.
 *
 * Um por bloco. Dois números do mesmo tamanho na mesma dobra obrigam o leitor a
 * escolher qual olhar primeiro, e ele escolhe errado.
 */
const NumeroProtagonista = ({ rotulo, valor, nivel, rotuloDaFaixa, cor, fonte, leitura, motivo, ajuda }) => (
  <Box>
    <Stack direction="row" spacing={1} alignItems="center">
      <Typography variant="overline" color="text.secondary" sx={{ letterSpacing: '0.06em' }}>
        {rotulo}
      </Typography>
      {/* O ALVO DA AJUDA MEDIA O TAMANHO DE UM CARACTERE.
          Era um "?" de 12px com `tabIndex`: alvo de ~8x14px para o dedo, contra
          os 44px que o resto do produto respeita. O glifo continua sendo o
          desenho — trocá-lo por um ícone mudaria o peso visual ao lado do
          rótulo —, mas o alvo cresce por pseudo-elemento, como já acontece na
          setinha da régua da lista: a densidade da linha não muda e o dedo
          passa a ter onde acertar. */}
      {ajuda && (
        <Tooltip title={ajuda}>
          <Typography
            component="span"
            variant="caption"
            tabIndex={0}
            role="button"
            aria-label={`O que é ${rotulo}`}
            sx={{
              position: 'relative',
              color: 'text.secondary',
              cursor: 'help',
              borderBottom: '1px dotted',
              lineHeight: 1,
              '&::after': {
                content: '""',
                position: 'absolute',
                top: '50%',
                left: '50%',
                width: 44,
                height: 44,
                transform: 'translate(-50%, -50%)'
              }
            }}
          >
            ?
          </Typography>
        </Tooltip>
      )}
    </Stack>

    <Stack direction="row" spacing={1.5} alignItems="center" flexWrap="wrap" useFlexGap>
      {/* O número é a peça mais pesada da dobra, e por isso ele é o único texto
          do produto que ganha tratamento ótico: peso 620, tracking negativo
          maior que o do título e altura de linha curta. Em corpo grande, o
          espaçamento que serve para 14px afasta demais os algarismos. */}
      <ValorQueChega>
        <Typography
          className="valor-numerico"
          sx={{
            fontSize: { xs: '2.25rem', sm: '2.75rem' },
            fontWeight: 620,
            lineHeight: 1.08,
            letterSpacing: '-0.032em',
            color: valor === null || valor === undefined ? 'text.disabled' : 'text.primary',
            textShadow: (t) =>
              t.palette.mode === 'dark' ? '0 0 28px rgba(160, 195, 235, 0.16)' : 'none'
          }}
        >
          {valor}
        </Typography>
      </ValorQueChega>
      {nivel && nivel !== 'semFaixa' && nivel !== 'ausente' && (
        <NivelChip nivel={nivel} rotulo={rotuloDaFaixa} cor={cor} fonte={fonte} />
      )}
    </Stack>

    {(leitura || motivo) && (
      <Typography
        variant="body2"
        color={motivo ? 'text.secondary' : 'text.primary'}
        sx={{ mt: 0.5, maxWidth: '65ch' }}
      >
        {leitura || motivo}
      </Typography>
    )}
  </Box>
);

export default NumeroProtagonista;
